import { createRoot } from "react-dom/client";
import { useListenFromRenderer } from "../message";

export function useListenOpenDialogMessage() {
	useListenFromRenderer([
		{
			key: "openDialog",
			onMessage: (msg) => {
				const { title, url, width, height } = msg.values;
				if (title && url && width && height) {
					const openModal = async () => {
						const newDialog = document.createElement("dialog");
						newDialog.style.width = "100%";
						newDialog.style.height = "100%";
						newDialog.style.padding = "0";
						createRoot(newDialog).render(
							<webview
								className="webview"
								src={url}
								style={{ width: "100%", height: "100%" }}
							/>,
						);
						document.body.appendChild(newDialog);
						// @ts-ignore
						const _result = await newDialog.showModal({
							title,
							resize: "both",
							size: {
								width,
								height,
							},
						});

						newDialog.remove();
					};
					openModal();
				}
			},
		},
	]);
}
